import React from 'react';
import ReactDOM from 'react-dom';
// import registerServiceWorker from './registerServiceWorker';
import HubTheme from './theme'
import AuthLayer from './containers/AuthLayer'

import './index.css';

ReactDOM.render(
  <HubTheme>
    <AuthLayer />
  </HubTheme>,
  document.getElementById('root')
);

// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities.
// TODO: We should review if this is desired behavior. It came with the react-create-app defaults.
// NOTE: I turned off the serviceWorker, because the caching was so strong that when switching from admin to a regular
// user, the full list of datasets was still displayed.
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js